import type { GridPinnedColumnFields } from '@mui/x-data-grid-pro';
import type { TableColumnDTO } from '@tempo-io/roadmap-dto';
import { buildTableColumnField } from './tableColumnUtils';

export type ColumnMoveDirection = 'left' | 'right';

const isPinned = (field: string, pinnedColumns: GridPinnedColumnFields): boolean =>
  Boolean(pinnedColumns.left?.includes(field)) || Boolean(pinnedColumns.right?.includes(field));

export const getMoveColumnOrder = (
  layoutColumns: TableColumnDTO[],
  field: string,
  pinnedColumns: GridPinnedColumnFields,
  direction: ColumnMoveDirection,
): TableColumnDTO[] | undefined => {
  if (isPinned(field, pinnedColumns)) return undefined;

  const fields = layoutColumns.map(buildTableColumnField);
  const currentIndex = fields.indexOf(field);
  if (currentIndex === -1) return undefined;

  const step = direction === 'left' ? -1 : 1;
  let neighborIndex = currentIndex + step;
  let neighborField = fields[neighborIndex];
  while (neighborField !== undefined && isPinned(neighborField, pinnedColumns)) {
    neighborIndex += step;
    neighborField = fields[neighborIndex];
  }
  if (neighborField === undefined) return undefined;

  const current = layoutColumns[currentIndex];
  const neighbor = layoutColumns[neighborIndex];
  if (!current || !neighbor) return undefined;

  const reordered = [...layoutColumns];
  reordered[currentIndex] = neighbor;
  reordered[neighborIndex] = current;
  return reordered;
};
